import i18n from "i18next";
export function friendlyReason(msg: string, ps: string) {
    // use bank-provided message if it's not empty and not "OK"
    if (msg && msg.toUpperCase() !== 'OK') return msg;

    // fallback by paymentStatus
    switch (ps) {
        case '3': return i18n.t('payment_fail.3');
        case '2': return  i18n.t('payment_fail.2');
        case '1': return  i18n.t('payment_fail.1');
        case '5': return  i18n.t('payment_fail.5');
        case '6': return i18n.t('payment_fail.6');
        case '7': return i18n.t('payment_fail.succ');
        case '4': return i18n.t('payment_fail.succ');
        case '8': return  i18n.t('payment_fail.succ');
        default:  return  i18n.t('payment_fail.def');
    }
}
